module.exports = __webpack_public_path__ + "img/bg-892522.jpg";